import { all, takeEvery, takeLatest } from 'redux-saga/effects';

import {
  filingTypesCreateStart,
  filingTypesDeleteStart,
  filingTypesFetchStart,
  filingTypesOptionsFetchStart,
  filingTypesUpdateStart,
} from '@store/entityJurisdictions/entityJurisdictionsDetail/filingTypes/filingTypes.reducer';

import { filingTypeOptionsFetchSaga } from './filingTypeOptionsFetchSaga';
import { filingTypesCreateSaga } from './filingTypesCreateSaga';
import { filingTypesDeleteSaga } from './filingTypesDeleteSaga';
import { filingTypesFetchSaga } from './filingTypesFetchSaga';
import { filingTypesUpdateSaga } from './filingTypesUpdateSaga';

export default all([
  takeEvery(filingTypesCreateStart.type, filingTypesCreateSaga),
  takeEvery(filingTypesUpdateStart.type, filingTypesUpdateSaga),
  takeEvery(filingTypesDeleteStart.type, filingTypesDeleteSaga),
  takeLatest(filingTypesFetchStart.type, filingTypesFetchSaga),
  takeEvery(filingTypesOptionsFetchStart.type, filingTypeOptionsFetchSaga),
]);
